import AuthContext from 'context/auth/authContext'
import Footer from 'components/Footer/Footer.jsx'
import SubmissionNavbar from 'components/Navbars/SubmissionNavbar'
import Sidebar from 'components/Sidebar/Sidebar.jsx'
import PerfectScrollbar from 'perfect-scrollbar'
import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState, useContext } from 'react'
import { Redirect, useHistory, useLocation } from 'react-router-dom'
import LayoutRoutes from 'routes/LayoutRoutes'
import SidebarRoutes from 'routes/SidebarRoutes'
import PageContext from 'context/page/pageContext'
import { useOktaAuth } from '@okta/okta-react'

let ps

const Submission = props => {
  const authContext = useContext(AuthContext)
  const { loadUser } = authContext
  const { authState } = useOktaAuth()

  const pageContext = useContext(PageContext)
  const { scrollToTop, setScrollToTop } = pageContext

  const [state] = useState({
    backgroundColor: 'white',
    activeColor: 'success',
    sidebarMini: false,
  })

  const location = useLocation()
  const history = useHistory()

  const mainPanel = useRef(null)

  useEffect(() => {
    console.log('mainPanel.current.scrollTop = 0')
    console.log('history.action is: ' + history.action)
  }, [history.action])

  useEffect(() => {
    if (authState.isAuthenticated) {
      loadUser()

      if (navigator.platform.indexOf('Win') > -1) {
        document.documentElement.className += ' perfect-scrollbar-on'
        document.documentElement.classList.remove('perfect-scrollbar-off')
        ps = new PerfectScrollbar(mainPanel.current)
      }
      if (history.action === 'PUSH' || scrollToTop) {
        document.documentElement.scrollTop = 0
        if (document.scrollingElement !== null)
          document.scrollingElement.scrollTop = 0
        mainPanel.current.scrollTop = 0
        if (scrollToTop) setScrollToTop(false)
      }
    }
    return () => {
      if (navigator.platform.indexOf('Win') > -1) {
        if (ps) {
          ps.destroy()
        }
        document.documentElement.className += ' perfect-scrollbar-off'
        document.documentElement.classList.remove('perfect-scrollbar-on')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainPanel, history.action, authState.isAuthenticated, scrollToTop])

  const handleMiniClick = () => {
    // setState(
    //   document.body.classList.contains('sidebar-mini')
    //     ? { ...state, sidebarMini: false }
    //     : { ...state, sidebarMini: true }
    // )
    // document.body.classList.toggle('sidebar-mini')
  }

  return authState.isAuthenticated ? (
    <div className="wrapper">
      <Sidebar
        routes={SidebarRoutes()}
        bgColor={state.backgroundColor}
        activeColor={state.activeColor}
        {...props}
      />
      <div className="main-panel" ref={mainPanel}>
        <SubmissionNavbar {...props} handleMiniClick={handleMiniClick} />
        <LayoutRoutes />

        {// we don't want the Footer to be rendered on full screen maps page
        location.pathname.indexOf('full-screen-map') !== -1 ? null : (
          <Footer fluid />
        )}
      </div>
    </div>
  ) : (
    <Redirect to="/auth/login" />
  )
}

Submission.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
}

export default Submission
